import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import {showConfirmAlert} from 'services/alert'
import {useEditMeterReadingMutation} from 'store/Store'
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded'

const NewMeterMenuItem = ({itemId, handleClose, rowData}) => {
    const [editMeterReading] = useEditMeterReadingMutation()
    const {t} = useTranslation()

    const isAlreadyNewMeter = Boolean(rowData?.is_new_meter)

    const onClickHandler = (e) => {
        handleClose?.(e)
        showConfirmAlert({
            e,
            text: isAlreadyNewMeter
                ? t('meter_readings.newMeter.confirmUnmark')
                : t('meter_readings.newMeter.confirmMark'),
            onConfirm: () =>
                toast.promise(
                    editMeterReading({
                        _id: itemId,
                        is_new_meter: !isAlreadyNewMeter,
                    }).unwrap(),
                    {
                        loading: t('loading'),
                        success: () =>
                            isAlreadyNewMeter
                                ? t('meter_readings.newMeter.unmarked')
                                : t('meter_readings.newMeter.marked'),
                        error: (err) =>
                            err?.data?.error || t('meter_readings.newMeter.error'),
                    }
                ),
            disableSuccessAlert: true,
            t,
        })
    }

    return (
        <MenuItem key={`table_action_new_meter_${itemId}`} onClick={onClickHandler}>
            <Box display="flex" justifyContent="space-between" width="100%" gap={1}>
                <div>
                    {isAlreadyNewMeter
                        ? t('menuItem.unmark_new_meter')
                        : t('menuItem.mark_new_meter')}
                </div>
                <SwapHorizRoundedIcon />
            </Box>
        </MenuItem>
    )
}

export default NewMeterMenuItem
